module.exports = __webpack_public_path__ + "assets/img/header.3d52689c.webp";